import type React from "react";
import { useNavigate } from "react-router";

import ImageParty from "@/assets/images/party.png";
import { Button } from "@/components/Button/Button";
import { Modal, type ModalBaseProps } from "@/components/Modal/Modal";
import { useSlug } from "@/hooks/useSlug";
import { routes } from "@/routes";
import { useTranslation } from "@/translations";

type SurveyRespondSuccessModalProps = ModalBaseProps & {
  message: string;
};

export function SurveyRespondSuccessModal({
  message,
  isOpened,
  onOpenChange,
}: SurveyRespondSuccessModalProps): React.ReactNode {
  const navigate = useNavigate();
  const slug = useSlug();
  const { t } = useTranslation();

  const handleClose = () => {
    void navigate(routes.messageFeed.list({ slug }));
  };

  return (
    <Modal.Root
      title={t("page.survey-respond.success-modal.title")}
      onOpenChange={(state) => {
        if (!state) {
          handleClose();
        }

        onOpenChange(state);
      }}
      data-testid="survey-respond-success-modal"
      {...{ isOpened }}
    >
      <div className="flex w-full flex-col items-center gap-4">
        <div className="flex w-full justify-center">
          <img className="w-24 py-6" src={ImageParty} alt="success" />
        </div>
        <p className="max-w-[440px] text-center text-body">{message}</p>
      </div>
      <Modal.Actions>
        <Modal.Close>
          <Button data-testid="survey-respond-success-modal-close-btn">
            {t("page.survey-respond.success-modal.button.continue")}
          </Button>
        </Modal.Close>
      </Modal.Actions>
    </Modal.Root>
  );
}
